import { Injectable, Injector } from "@angular/core";
import { QueryNodeMessageBox } from "../QueryNodeMessageBox";
import { FieldDefinitionConditions } from "../../../../../sections/webtrader/webtrader/message/fieldDefinition-conditions";
import { ServiceEnum } from "../../../ServiceEnum";
import { EntityEnum } from "../../EntityEnum";
import { QueryConditionNodeFromEudravigilance } from "./QueryConditionNodeFromEudravigilance";
import { FromEudravigilanceListView } from "../../../Data/WebTraderData/FromEudravigilanceListView";
import { ResultListNodeFromEudravigilance } from "../ListEntity/ResultListNodeFromEudravigilance";

@Injectable({
  providedIn: 'root',
})
export class QueryNodeFromEudravigilance extends QueryNodeMessageBox {

  constructor(injector: Injector) {
    super(injector, new FromEudravigilanceListView([]), 'From Eudravigilance', EntityEnum.fromEV, ServiceEnum.Webtrader);
    this.children!.push(new QueryConditionNodeFromEudravigilance(injector, new FieldDefinitionConditions(injector).queryFromEudravigilanceConditions));
    this.children!.push(new ResultListNodeFromEudravigilance(injector));
  }

  override reset(): void {
    this.children = [];
    this.children!.push(new QueryConditionNodeFromEudravigilance(this.ioc!, new FieldDefinitionConditions(this.ioc!).queryFromEudravigilanceConditions));
    this.children!.push(new ResultListNodeFromEudravigilance(this.ioc!));
  }

}